import { useNavigate, useParams } from 'react-router-dom';
import { App, Form, Skeleton } from 'antd';
import React, { useEffect, useState } from 'react';

import {
    useLazyReadBannerQuery,
    useUpdateBannerMutation,
} from '../service/banners';
import { createFormData } from '../../../../../utils/common/createFormData';
import { BannerForm } from '../components';
import { Page } from '../../../../../shared/ui/Page';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';
import { Save } from '../../../widgets/Save';

export const BannerEditContainer = () => {
    const { bannerId } = useParams();
    const current = useAppSelector(selectShopCurrent);
    const { notification } = App.useApp();

    const navigate = useNavigate();

    const [form] = Form.useForm();
    const values = Form.useWatch([], form);
    const [isSubmittable, setIsSubmittable] = useState<boolean>(false);

    const [updateBanner, { isSuccess, isError, isLoading: isLoadingUpdate }] =
        useUpdateBannerMutation();
    const [getBanner, { data, isLoading: isLoading }] =
        useLazyReadBannerQuery();

    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: 'Баннер успешно сохранен',
            });
            navigate(-1);
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError) {
            notification.error({
                message: 'Ошибка при сохранении',
            });
        }
    }, [isError]);

    useEffect(() => {
        if (current.id && bannerId) {
            const payload = {
                shopId: current.id,
                bannerId: +bannerId,
            };
            getBanner(payload, true);
        }
    }, [current.id, bannerId]);

    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                url: data.url,
                image: data.images.original,
            });
        }
    }, [data]);

    useEffect(() => {
        form.validateFields({ validateOnly: true })
            .then(() => setIsSubmittable(true))
            .catch(() => setIsSubmittable(false));
    }, [form, values]);

    const save = async () => {
        const payload = {
            id: current.id,
            bannerId: +bannerId,
            ...values,
        };

        if (!(values.image instanceof File)) {
            delete payload.image;
        }

        if (values.url === undefined) {
            delete payload.url;
        }

        await updateBanner({
            id: current.id,
            bannerId: +bannerId,
            body: createFormData(payload),
        });
    };

    return (
        <Page title={'Редактирование баннера'} isBackButton>
            {isLoading ? (
                <Skeleton />
            ) : (
                <BannerForm isEdit={true} form={form} values={values} />
            )}
            <Save
                onSave={save}
                disabled={isLoading || !isSubmittable}
                loading={isLoading || isLoadingUpdate}
            />
        </Page>
    );
};
